import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, ModalResult, PreLoginModalComponent as ModalComponent } from './pre-login-modal.component';

@Injectable({ providedIn: 'root' })
export class PreLoginModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions & { beforeDismiss?: never }) {
    if (properties?.blockDismiss) {
      options = options || {};
      (options as NgbModalOptions).beforeDismiss = () => {
        return false;
      };
    }

    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
